import React from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import BaseReports from '../../AbstractObjects/GatewayPlan/InnerPages/BaseReports';

const pageSchema = GatewayGetSchema.pages.reports;
const pageId = pageSchema.pageId;

function PlanReports({
    planObject,
    setPlanData,
    isSMEReportEnabled,
    isReportConfirmationEnabled
}) {
    let pageData = planObject[pageId];
    
    return (
        <BaseReports
            pageData={pageData}
            setObjectData={setPlanData}
            isSMEReportEnabled={isSMEReportEnabled}
            isReportConfirmationEnabled={isReportConfirmationEnabled}
        />
    );
}

export default PlanReports;